import { render, staticRenderFns } from "./myFormItem.vue?vue&type=template&id=251ded53"
import script from "./myFormItem.vue?vue&type=script&lang=js"
export * from "./myFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports